<template>
  <div
    class="space-y-2 [&_a:hover]:text-orange-500 [&_a]:transition-colors"
    data-testid="footer-column"
  >
    <div>
      <h3 class="mb-6 font-sans text-xl font-medium">
        {{ column.name }}
      </h3>
    </div>
    <template v-for="item in column.children" :key="item.id">
      <NuxtLink
        :to="getLocalizedRoute(item.options?.url)"
        class="block text-md font-normal"
      >
        {{ item.name }}
      </NuxtLink>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { NavigationTreeItem } from '@scayle/storefront-nuxt'
import { NuxtLink } from '#components'
import { useRouteHelpers } from '~/composables'

defineProps<{
  column: NavigationTreeItem
}>()

const { getLocalizedRoute } = useRouteHelpers()

defineOptions({ name: 'SFFooterNavColumn' })
</script>
